import React from 'react';
import FormInput from './FormInput';

const PopulationAndPrice = ({
  formData,
  handleChange,
  handleFocus,
  handleBlur,
  getDisplayValue
}) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      <FormInput
        label="Price Guide Value"
        name="price_guide_value"
        value={getDisplayValue('price_guide_value', formData.price_guide_value)}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />

      <FormInput
        label="List Price"
        name="list_price"
        value={getDisplayValue('list_price', formData.list_price)}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />

      <FormInput
        label="Population"
        name="population"
        value={getDisplayValue('population', formData.population)}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />

      <FormInput
        label="Population Higher"
        name="pop_higher"
        value={getDisplayValue('pop_higher', formData.pop_higher)}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
    </div>
  );
};

export default PopulationAndPrice;
